export default [
  {
    title: 'breadcrumb.transaction',
    route: 'list-transaction',
    icon: '',
    resource: 'transaction',
    action: 'read',
  },
]
